// 国家和币种
// 国家和币种
const COUNTRY_CURRENCY = [
  {
    "country_name": "加拿大",
    "country_name_en": "Canada",
    "country_code": "CA",
    "currency_code": "CAD",
    "shipping_trackit": 365,
    "shipping_mh": 970,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "10.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "法国",
    "country_name_en": "France",
    "country_code": "FR",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "20.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "德国",
    "country_name_en": "Germany",
    "country_code": "DE",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "19.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "英国",
    "country_name_en": "United Kingdom",
    "country_code": "GB",
    "currency_code": "GBP",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "20.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 5,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "阿森松岛",
    "country_name_en": "Ascension Island",
    "country_code": "AC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "安道尔",
    "country_name_en": "Andorra",
    "country_code": "AD",
    "currency_code": "USD",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "阿拉伯联合酋长国",
    "country_name_en": "United Arab Emirates",
    "country_code": "AE",
    "currency_code": "USD",
    "shipping_trackit": 330,
    "shipping_mh": 1113,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "阿富汗",
    "country_name_en": "Afghanistan",
    "country_code": "AF",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "安提瓜和巴布达",
    "country_name_en": "Antigua and Barbuda",
    "country_code": "AG",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "安圭拉",
    "country_name_en": "Anguilla",
    "country_code": "AI",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "阿尔巴尼亚",
    "country_name_en": "Albania",
    "country_code": "AL",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "亚美尼亚",
    "country_name_en": "Armenia",
    "country_code": "AM",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "安哥拉",
    "country_name_en": "Angola",
    "country_code": "AO",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "阿根廷",
    "country_name_en": "Argentina",
    "country_code": "AR",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 9,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "澳大利亚",
    "country_name_en": "Australia",
    "country_code": "AU",
    "currency_code": "AUD",
    "shipping_trackit": 180,
    "shipping_mh": 692,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "10.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "阿鲁巴",
    "country_name_en": "Aruba",
    "country_code": "AW",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "奥兰群岛",
    "country_name_en": "Åland Islands",
    "country_code": "AX",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "阿塞拜疆",
    "country_name_en": "Azerbaijan",
    "country_code": "AZ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "波斯尼亚和黑塞哥维那",
    "country_name_en": "Bosnia and Herzegovina",
    "country_code": "BA",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "巴巴多斯",
    "country_name_en": "Barbados",
    "country_code": "BB",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "孟加拉国",
    "country_name_en": "Bangladesh",
    "country_code": "BD",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "布基纳法索",
    "country_name_en": "Burkina Faso",
    "country_code": "BF",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "巴林",
    "country_name_en": "Bahrain",
    "country_code": "BH",
    "currency_code": "USD",
    "shipping_trackit": 330,
    "shipping_mh": 1113,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "布隆迪",
    "country_name_en": "Burundi",
    "country_code": "BI",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "贝宁",
    "country_name_en": "Benin",
    "country_code": "BJ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣巴泰勒米",
    "country_name_en": "Saint Barthélemy",
    "country_code": "BL",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "百慕大",
    "country_name_en": "Bermuda",
    "country_code": "BM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "文莱",
    "country_name_en": "Brunei",
    "country_code": "BN",
    "currency_code": "USD",
    "shipping_trackit": 390,
    "shipping_mh": 1173,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "玻利维亚",
    "country_name_en": "Bolivia",
    "country_code": "BO",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "荷属加勒比区",
    "country_name_en": "Caribbean Netherlands",
    "country_code": "BQ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "巴西",
    "country_name_en": "Brazil",
    "country_code": "BR",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 9,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "巴哈马",
    "country_name_en": "Bahamas",
    "country_code": "BS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "不丹",
    "country_name_en": "Bhutan",
    "country_code": "BT",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "博茨瓦纳",
    "country_name_en": "Botswana",
    "country_code": "BW",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "白俄罗斯",
    "country_name_en": "Belarus",
    "country_code": "BY",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1162,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "伯利兹",
    "country_name_en": "Belize",
    "country_code": "BZ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "科科斯（基林）群岛",
    "country_name_en": "Cocos (Keeling) Islands",
    "country_code": "CC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "刚果（金）",
    "country_name_en": "Democratic Republic of the Congo",
    "country_code": "CD",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "中非共和国",
    "country_name_en": "Central African Republic",
    "country_code": "CF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "刚果（布）",
    "country_name_en": "Republic of the Congo",
    "country_code": "CG",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "瑞士",
    "country_name_en": "Switzerland",
    "country_code": "CH",
    "currency_code": "USD",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 200
  },
  {
    "country_name": "科特迪瓦",
    "country_name_en": "Côte d'Ivoire",
    "country_code": "CI",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "库克群岛",
    "country_name_en": "Cook Islands",
    "country_code": "CK",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "智利",
    "country_name_en": "Chile",
    "country_code": "CL",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 9,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "喀麦隆",
    "country_name_en": "Cameroon",
    "country_code": "CM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "中国",
    "country_name_en": "China",
    "country_code": "CN",
    "currency_code": "USD",
    "shipping_trackit": "/",
    "shipping_mh": 1150,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 0,
    "shipping_05": 0,
    "shipping_10": 0,
    "shipping_20": 0,
    "shipping_100": 0,
    "shipping_150": 0
  },
  {
    "country_name": "哥伦比亚",
    "country_name_en": "Colombia",
    "country_code": "CO",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 9,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "哥斯达黎加",
    "country_name_en": "Costa Rica",
    "country_code": "CR",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "佛得角",
    "country_name_en": "Cape Verde",
    "country_code": "CV",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "库拉索",
    "country_name_en": "Curaçao",
    "country_code": "CW",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣诞岛",
    "country_name_en": "Christmas Island",
    "country_code": "CX",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "吉布提",
    "country_name_en": "Djibouti",
    "country_code": "DJ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "多米尼克",
    "country_name_en": "Dominica",
    "country_code": "DM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "多米尼加共和国",
    "country_name_en": "Dominican Republic",
    "country_code": "DO",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "阿尔及利亚",
    "country_name_en": "Algeria",
    "country_code": "DZ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "厄瓜多尔",
    "country_name_en": "Ecuador",
    "country_code": "EC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "埃及",
    "country_name_en": "Egypt",
    "country_code": "EG",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "西撒哈拉",
    "country_name_en": "Western Sahara",
    "country_code": "EH",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "厄立特里亚",
    "country_name_en": "Eritrea",
    "country_code": "ER",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "埃塞俄比亚",
    "country_name_en": "Ethiopia",
    "country_code": "ET",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "斐济",
    "country_name_en": "Fiji",
    "country_code": "FJ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "福克兰群岛",
    "country_name_en": "Falkland Islands",
    "country_code": "FK",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "法罗群岛",
    "country_name_en": "Faroe Islands",
    "country_code": "FO",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "加蓬",
    "country_name_en": "Gabon",
    "country_code": "GA",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "格林纳达",
    "country_name_en": "Grenada",
    "country_code": "GD",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "格鲁吉亚",
    "country_name_en": "Georgia",
    "country_code": "GE",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "法属圭亚那",
    "country_name_en": "French Guiana",
    "country_code": "GF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "根西岛",
    "country_name_en": "Guernsey",
    "country_code": "GG",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "加纳",
    "country_name_en": "Ghana",
    "country_code": "GH",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "直布罗陀",
    "country_name_en": "Gibraltar",
    "country_code": "GI",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "格陵兰",
    "country_name_en": "Greenland",
    "country_code": "GL",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "冈比亚",
    "country_name_en": "Gambia",
    "country_code": "GM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "几内亚",
    "country_name_en": "Guinea",
    "country_code": "GN",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "瓜德罗普",
    "country_name_en": "Guadeloupe",
    "country_code": "GP",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "赤道几内亚",
    "country_name_en": "Equatorial Guinea",
    "country_code": "GQ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "南乔治亚和南桑威奇群岛",
    "country_name_en": "South Georgia and the South Sandwich Islands",
    "country_code": "GS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "危地马拉",
    "country_name_en": "Guatemala",
    "country_code": "GT",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "几内亚比绍",
    "country_name_en": "Guinea-Bissau",
    "country_code": "GW",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圭亚那",
    "country_name_en": "Guyana",
    "country_code": "GY",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "香港特别行政区",
    "country_name_en": "Hong Kong",
    "country_code": "HK",
    "currency_code": "USD",
    "shipping_trackit": 80,
    "shipping_mh": 247,
    "shipping_sm": 9.9,
    "shipping_md": 9.9,
    "shipping_lg": 9.9,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 80
  },
  {
    "country_name": "洪都拉斯",
    "country_name_en": "Honduras",
    "country_code": "HN",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "海地",
    "country_name_en": "Haiti",
    "country_code": "HT",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "印度尼西亚",
    "country_name_en": "Indonesia",
    "country_code": "ID",
    "currency_code": "USD",
    "shipping_trackit": 200,
    "shipping_mh": 481,
    "shipping_sm": 25,
    "shipping_md": 35,
    "shipping_lg": 50,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 200
  },
  {
    "country_name": "以色列",
    "country_name_en": "Israel",
    "country_code": "IL",
    "currency_code": "USD",
    "shipping_trackit": 430,
    "shipping_mh": 1104,
    "shipping_sm": 40,
    "shipping_md": 50,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "马恩岛",
    "country_name_en": "Isle of Man",
    "country_code": "IM",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "印度",
    "country_name_en": "India",
    "country_code": "IN",
    "currency_code": "USD",
    "shipping_trackit": 300,
    "shipping_mh": 581,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "英属印度洋领地",
    "country_name_en": "British Indian Ocean Territory",
    "country_code": "IO",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "伊拉克",
    "country_name_en": "Iraq",
    "country_code": "IQ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "冰岛",
    "country_name_en": "Iceland",
    "country_code": "IS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 50,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "泽西岛",
    "country_name_en": "Jersey",
    "country_code": "JE",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "牙买加",
    "country_name_en": "Jamaica",
    "country_code": "JM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "约旦",
    "country_name_en": "Jordan",
    "country_code": "JO",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "肯尼亚",
    "country_name_en": "Kenya",
    "country_code": "KE",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "吉尔吉斯斯坦",
    "country_name_en": "Kyrgyzstan",
    "country_code": "KG",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "柬埔寨",
    "country_name_en": "Cambodia",
    "country_code": "KH",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1089,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "基里巴斯",
    "country_name_en": "Kiribati",
    "country_code": "KI",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "科摩罗",
    "country_name_en": "Comoros",
    "country_code": "KM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣基茨和尼维斯",
    "country_name_en": "Saint Kitts and Nevis",
    "country_code": "KN",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "韩国",
    "country_name_en": "South Korea",
    "country_code": "KR",
    "currency_code": "USD",
    "shipping_trackit": 80,
    "shipping_mh": 255,
    "shipping_sm": 20,
    "shipping_md": 25,
    "shipping_lg": 30,
    "tax": "10.00",
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 10,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 120
  },
  {
    "country_name": "科威特",
    "country_name_en": "Kuwait",
    "country_code": "KW",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "开曼群岛",
    "country_name_en": "Cayman Islands",
    "country_code": "KY",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "哈萨克斯坦",
    "country_name_en": "Kazakhstan",
    "country_code": "KZ",
    "currency_code": "USD",
    "shipping_trackit": 330,
    "shipping_mh": 1113,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "老挝",
    "country_name_en": "Laos",
    "country_code": "LA",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "黎巴嫩",
    "country_name_en": "Lebanon",
    "country_code": "LB",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "圣卢西亚",
    "country_name_en": "Saint Lucia",
    "country_code": "LC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "列支敦士登",
    "country_name_en": "Liechtenstein",
    "country_code": "LI",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "斯里兰卡",
    "country_name_en": "Sri Lanka",
    "country_code": "LK",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "利比里亚",
    "country_name_en": "Liberia",
    "country_code": "LR",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "莱索托",
    "country_name_en": "Lesotho",
    "country_code": "LS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "利比亚",
    "country_name_en": "Libya",
    "country_code": "LY",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "摩洛哥",
    "country_name_en": "Morocco",
    "country_code": "MA",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "摩纳哥",
    "country_name_en": "Monaco",
    "country_code": "MC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "摩尔多瓦",
    "country_name_en": "Moldova",
    "country_code": "MD",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "黑山",
    "country_name_en": "Montenegro",
    "country_code": "ME",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "法属圣马丁",
    "country_name_en": "Saint Martin",
    "country_code": "MF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "马达加斯加",
    "country_name_en": "Madagascar",
    "country_code": "MG",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "北马其顿",
    "country_name_en": "North Macedonia",
    "country_code": "MK",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "马里",
    "country_name_en": "Mali",
    "country_code": "ML",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "缅甸",
    "country_name_en": "Myanmar",
    "country_code": "MM",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "蒙古",
    "country_name_en": "Mongolia",
    "country_code": "MN",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "澳门特别行政区",
    "country_name_en": "Macao",
    "country_code": "MO",
    "currency_code": "USD",
    "shipping_trackit": 80,
    "shipping_mh": 247,
    "shipping_sm": 9.9,
    "shipping_md": 9.9,
    "shipping_lg": 9.9,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 80
  },
  {
    "country_name": "马提尼克",
    "country_name_en": "Martinique",
    "country_code": "MQ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "毛里塔尼亚",
    "country_name_en": "Mauritania",
    "country_code": "MR",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "蒙特塞拉特",
    "country_name_en": "Montserrat",
    "country_code": "MS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "毛里求斯",
    "country_name_en": "Mauritius",
    "country_code": "MU",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "马尔代夫",
    "country_name_en": "Maldives",
    "country_code": "MV",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "马拉维",
    "country_name_en": "Malawi",
    "country_code": "MW",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "墨西哥",
    "country_name_en": "Mexico",
    "country_code": "MX",
    "currency_code": "USD",
    "shipping_trackit": 365,
    "shipping_mh": 970,
    "shipping_sm": 25,
    "shipping_md": 35,
    "shipping_lg": 50,
    "tax": "16.80",
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 300
  },
  {
    "country_name": "马来西亚",
    "country_name_en": "Malaysia",
    "country_code": "MY",
    "currency_code": "USD",
    "shipping_trackit": 100,
    "shipping_mh": 268,
    "shipping_sm": 20,
    "shipping_md": 25,
    "shipping_lg": 30,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 120
  },
  {
    "country_name": "莫桑比克",
    "country_name_en": "Mozambique",
    "country_code": "MZ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "纳米比亚",
    "country_name_en": "Namibia",
    "country_code": "NA",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "新喀里多尼亚",
    "country_name_en": "New Caledonia",
    "country_code": "NC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "尼日尔",
    "country_name_en": "Niger",
    "country_code": "NE",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "诺福克岛",
    "country_name_en": "Norfolk Island",
    "country_code": "NF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "尼日利亚",
    "country_name_en": "Nigeria",
    "country_code": "NG",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "尼加拉瓜",
    "country_name_en": "Nicaragua",
    "country_code": "NI",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "尼泊尔",
    "country_name_en": "Nepal",
    "country_code": "NP",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "瑙鲁",
    "country_name_en": "Nauru",
    "country_code": "NR",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "纽埃",
    "country_name_en": "Niue",
    "country_code": "NU",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "新西兰",
    "country_name_en": "New Zealand",
    "country_code": "NZ",
    "currency_code": "USD",
    "shipping_trackit": 280,
    "shipping_mh": 792,
    "shipping_sm": 40,
    "shipping_md": 50,
    "shipping_lg": 60,
    "tax": "19.00",
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 200
  },
  {
    "country_name": "阿曼",
    "country_name_en": "Oman",
    "country_code": "OM",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "巴拿马",
    "country_name_en": "Panama",
    "country_code": "PA",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "秘鲁",
    "country_name_en": "Peru",
    "country_code": "PE",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "法属波利尼西亚",
    "country_name_en": "French Polynesia",
    "country_code": "PF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "巴布亚新几内亚",
    "country_name_en": "Papua New Guinea",
    "country_code": "PG",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "菲律宾",
    "country_name_en": "Philippines",
    "country_code": "PH",
    "currency_code": "USD",
    "shipping_trackit": 130,
    "shipping_mh": 324,
    "shipping_sm": 20,
    "shipping_md": 25,
    "shipping_lg": 30,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 120
  },
  {
    "country_name": "巴基斯坦",
    "country_name_en": "Pakistan",
    "country_code": "PK",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣皮埃尔和密克隆群岛",
    "country_name_en": "Saint Pierre and Miquelon",
    "country_code": "PM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "皮特凯恩群岛",
    "country_name_en": "Pitcairn Islands",
    "country_code": "PN",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "巴勒斯坦领土",
    "country_name_en": "Palestinian Territories",
    "country_code": "PS",
    "currency_code": "USD",
    "shipping_trackit": "/",
    "shipping_mh": 1283,
    "shipping_sm": null,
    "shipping_md": null,
    "shipping_lg": null
  },
  {
    "country_name": "巴拉圭",
    "country_name_en": "Paraguay",
    "country_code": "PY",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "卡塔尔",
    "country_name_en": "Qatar",
    "country_code": "QA",
    "currency_code": "USD",
    "shipping_trackit": 330,
    "shipping_mh": 1113,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 200
  },
  {
    "country_name": "留尼汪",
    "country_name_en": "Réunion",
    "country_code": "RE",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "塞尔维亚",
    "country_name_en": "Serbia",
    "country_code": "RS",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1324,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "俄罗斯",
    "country_name_en": "Russia",
    "country_code": "RU",
    "currency_code": "USD",
    "shipping_trackit": 330,
    "shipping_mh": 842,
    "shipping_sm": 30,
    "shipping_md": 45,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 200
  },
  {
    "country_name": "卢旺达",
    "country_name_en": "Rwanda",
    "country_code": "RW",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "沙特阿拉伯",
    "country_name_en": "Saudi Arabia",
    "country_code": "SA",
    "currency_code": "USD",
    "shipping_trackit": 330,
    "shipping_mh": 1113,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 200
  },
  {
    "country_name": "所罗门群岛",
    "country_name_en": "Solomon Islands",
    "country_code": "SB",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "塞舌尔",
    "country_name_en": "Seychelles",
    "country_code": "SC",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "苏丹",
    "country_name_en": "Sudan",
    "country_code": "SD",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "新加坡",
    "country_name_en": "Singapore",
    "country_code": "SG",
    "currency_code": "USD",
    "shipping_trackit": 110,
    "shipping_mh": 282,
    "shipping_sm": 20,
    "shipping_md": 25,
    "shipping_lg": 30,
    "tax": "8.00",
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 120
  },
  {
    "country_name": "圣赫勒拿",
    "country_name_en": "Saint Helena",
    "country_code": "SH",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "斯瓦尔巴和扬马延",
    "country_name_en": "Svalbard and Jan Mayen",
    "country_code": "SJ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1527,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "塞拉利昂",
    "country_name_en": "Sierra Leone",
    "country_code": "SL",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣马力诺",
    "country_name_en": "San Marino",
    "country_code": "SM",
    "currency_code": "USD",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "塞内加尔",
    "country_name_en": "Senegal",
    "country_code": "SN",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "索马里",
    "country_name_en": "Somalia",
    "country_code": "SO",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "苏里南",
    "country_name_en": "Suriname",
    "country_code": "SR",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "南苏丹",
    "country_name_en": "South Sudan",
    "country_code": "SS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣多美和普林西比",
    "country_name_en": "São Tomé and Príncipe",
    "country_code": "ST",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "萨尔瓦多",
    "country_name_en": "El Salvador",
    "country_code": "SV",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "荷属圣马丁",
    "country_name_en": "Sint Maarten",
    "country_code": "SX",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "斯威士兰",
    "country_name_en": "Eswatini",
    "country_code": "SZ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "特里斯坦-达库尼亚群岛",
    "country_name_en": "Tristan da Cunha",
    "country_code": "TA",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "特克斯和凯科斯群岛",
    "country_name_en": "Turks and Caicos Islands",
    "country_code": "TC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "乍得",
    "country_name_en": "Chad",
    "country_code": "TD",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "法属南部领地",
    "country_name_en": "French Southern Territories",
    "country_code": "TF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "多哥",
    "country_name_en": "Togo",
    "country_code": "TG",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "泰国",
    "country_name_en": "Thailand",
    "country_code": "TH",
    "currency_code": "USD",
    "shipping_trackit": 130,
    "shipping_mh": 341,
    "shipping_sm": 20,
    "shipping_md": 25,
    "shipping_lg": 30,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 120
  },
  {
    "country_name": "塔吉克斯坦",
    "country_name_en": "Tajikistan",
    "country_code": "TJ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "托克劳",
    "country_name_en": "Tokelau",
    "country_code": "TK",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "东帝汶",
    "country_name_en": "Timor-Leste",
    "country_code": "TL",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "土库曼斯坦",
    "country_name_en": "Turkmenistan",
    "country_code": "TM",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "突尼斯",
    "country_name_en": "Tunisia",
    "country_code": "TN",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "汤加",
    "country_name_en": "Tonga",
    "country_code": "TO",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "土耳其",
    "country_name_en": "Turkey",
    "country_code": "TR",
    "currency_code": "USD",
    "shipping_trackit": 390,
    "shipping_mh": 1173,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "特立尼达和多巴哥",
    "country_name_en": "Trinidad and Tobago",
    "country_code": "TT",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "图瓦卢",
    "country_name_en": "Tuvalu",
    "country_code": "TV",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "坦桑尼亚",
    "country_name_en": "Tanzania",
    "country_code": "TZ",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "乌克兰",
    "country_name_en": "Ukraine",
    "country_code": "UA",
    "currency_code": "USD",
    "shipping_trackit": "/",
    "shipping_mh": 1174,
    "shipping_sm": null,
    "shipping_md": null,
    "shipping_lg": null
  },
  {
    "country_name": "乌干达",
    "country_name_en": "Uganda",
    "country_code": "UG",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "美国本土外小岛屿",
    "country_name_en": "U.S. Outlying Islands",
    "country_code": "UM",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 40,
    "shipping_md": 50,
    "shipping_lg": 60,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "乌拉圭",
    "country_name_en": "Uruguay",
    "country_code": "UY",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "乌兹别克斯坦",
    "country_name_en": "Uzbekistan",
    "country_code": "UZ",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "梵蒂冈",
    "country_name_en": "Vatican City",
    "country_code": "VA",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "圣文森特和格林纳丁斯",
    "country_name_en": "Saint Vincent and the Grenadines",
    "country_code": "VC",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "委内瑞拉",
    "country_name_en": "Venezuela",
    "country_code": "VE",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "英属维尔京群岛",
    "country_name_en": "British Virgin Islands",
    "country_code": "VG",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "越南",
    "country_name_en": "Vietnam",
    "country_code": "VN",
    "currency_code": "USD",
    "shipping_trackit": 150,
    "shipping_mh": 383,
    "shipping_sm": 20,
    "shipping_md": 25,
    "shipping_lg": 30,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 10,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 120
  },
  {
    "country_name": "瓦努阿图",
    "country_name_en": "Vanuatu",
    "country_code": "VU",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "瓦利斯和富图纳",
    "country_name_en": "Wallis and Futuna",
    "country_code": "WF",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "萨摩亚",
    "country_name_en": "Samoa",
    "country_code": "WS",
    "currency_code": "USD",
    "shipping_trackit": 500,
    "shipping_mh": 1150,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "科索沃",
    "country_name_en": "Kosovo",
    "country_code": "XK",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1677,
    "shipping_sm": 80,
    "shipping_md": 120,
    "shipping_lg": 150,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "也门",
    "country_name_en": "Yemen",
    "country_code": "YE",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1433,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 7,
    "shipping_05": 15,
    "shipping_10": 30,
    "shipping_20": 40,
    "shipping_100": 200,
    "shipping_150": 650
  },
  {
    "country_name": "奥地利",
    "country_name_en": "Austria",
    "country_code": "AT",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "20.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "比利时",
    "country_name_en": "Belgium",
    "country_code": "BE",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "保加利亚",
    "country_name_en": "Bulgaria",
    "country_code": "BG",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "20.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "塞浦路斯",
    "country_name_en": "Cyprus",
    "country_code": "CY",
    "currency_code": "EUR",
    "shipping_trackit": 350,
    "shipping_mh": 862,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "19.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "捷克",
    "country_name_en": "Czech Republic",
    "country_code": "CZ",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "丹麦",
    "country_name_en": "Denmark",
    "country_code": "DK",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "25.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "爱沙尼亚",
    "country_name_en": "Estonia",
    "country_code": "EE",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "22.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "西班牙",
    "country_name_en": "Spain",
    "country_code": "ES",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "芬兰",
    "country_name_en": "Finland",
    "country_code": "FI",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "25.50",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "希腊",
    "country_name_en": "Greece",
    "country_code": "GR",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "24.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "南非",
    "country_name_en": "South Africa",
    "country_code": "ZA",
    "currency_code": "USD",
    "shipping_trackit": 650,
    "shipping_mh": 1274,
    "shipping_sm": 40,
    "shipping_md": 60,
    "shipping_lg": 80,
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650,
  },
  {
    "country_name": "克罗地亚",
    "country_name_en": "Croatia",
    "country_code": "HR",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "25.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "匈牙利",
    "country_name_en": "Hungary",
    "country_code": "HU",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "27.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "爱尔兰",
    "country_name_en": "Ireland",
    "country_code": "IE",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "23.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "意大利",
    "country_name_en": "Italy",
    "country_code": "IT",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "22.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "立陶宛",
    "country_name_en": "Lithuania",
    "country_code": "LT",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "卢森堡",
    "country_name_en": "Luxembourg",
    "country_code": "LU",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 1150,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "17.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "拉脱维亚",
    "country_name_en": "Latvia",
    "country_code": "LV",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "马耳他",
    "country_name_en": "Malta",
    "country_code": "MT",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "18.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 0,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "荷兰",
    "country_name_en": "Netherlands",
    "country_code": "NL",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "挪威",
    "country_name_en": "Norway",
    "country_code": "NO",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "25.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "波兰",
    "country_name_en": "Poland",
    "country_code": "PL",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "23.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "葡萄牙",
    "country_name_en": "Portugal",
    "country_code": "PT",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "23.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "罗马尼亚",
    "country_name_en": "Romania",
    "country_code": "RO",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 974,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "21.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "瑞典",
    "country_name_en": "Sweden",
    "country_code": "SE",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "25.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  },
  {
    "country_name": "斯洛文尼亚",
    "country_name_en": "Slovenia",
    "country_code": "SI",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "22.00",
    "shipping_aesub": 0,
    "shipping_ab6abp": 0,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 9,
    "shipping_10": 15,
    "shipping_20": 20,
    "shipping_100": 100,
    "shipping_150": 650
  },
  {
    "country_name": "斯洛伐克",
    "country_name_en": "Slovakia",
    "country_code": "SK",
    "currency_code": "EUR",
    "shipping_trackit": 300,
    "shipping_mh": 812,
    "shipping_sm": 0,
    "shipping_md": 0,
    "shipping_lg": 0,
    "tax": "23.00",
    "shipping_aesub": 9,
    "shipping_ab6abp": 6,
    "shipping_power": 9,
    "shipping_02": 5,
    "shipping_05": 5,
    "shipping_10": 10,
    "shipping_20": 15,
    "shipping_100": 50,
    "shipping_150": 200
  }
]


// 全球站所有市场
const markets = [
  {
    id: 'gid://shopify/Market/1669365995',
    name: 'Canada',
    handle: 'b154a6b2-878e-4c36-af7c-22aee132a577',
  },
  {
    id: 'gid://shopify/Market/15272607979',
    name: 'EUR',
    handle: 'eur',
  },
  {
    id: 'gid://shopify/Market/20965621995',
    name: 'France',
    handle: '法国',
  },
  {
    id: 'gid://shopify/Market/20965785835',
    name: 'Germany',
    handle: 'germany',
  },
  {
    id: 'gid://shopify/Market/1669398763',
    name: 'International',
    handle: 'international',
  },
  {
    id: 'gid://shopify/Market/15268282603',
    name: 'UK',
    handle: 'uk',
  },
];
// 币种
const CURRENCY_MAP = {
  USD: {
    currencyCode: 'EUR',
    currencyName: '美元',
    currencySymbol: '$'
  },
  EUR: {
    currencyCode: 'USD',
    currencyName: '欧元',
    currencySymbol: '€'
  },
  GBP: {
    currencyCode: 'GBP',
    currencyName: '英镑',
    currencySymbol: '£'
  },
}

const countrySelectionDom = $('#countrySelection')
let countryOptionDom = COUNTRY_CURRENCY.reduce((prev, next) => {
  return `${prev} 
  <option value="${next.country_code}" data-currency-code="${next.currency_code}" data-country-code="${next.country_code}">${next.country_name_en}</option>
  `
}, '')
countryOptionDom = '<option value="" selected>Please select</option>' + countryOptionDom

// console.log(`%c>> $`, 'color:yellow', countryOptionDom)

countrySelectionDom.html(countryOptionDom)
